import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@components/button/button';
import { getModalService } from 'src/shell/infrastructure/getters';

import { StyledDeleteModal } from '@components/delete-modal/delete.styled';


type Props = {
	onSubmit(): Promise<void>;
	title?: string;
	text?: string;
};
export default function DeleteModal({ onSubmit, title, text }: Props) {
	const { t } = useTranslation();
	const modalService = getModalService();
	const [submitting, setSubmitting] = useState(false);

	const handleConfirm = useCallback(async () => {
		if (submitting) {
			return;
		}

		setSubmitting(true);
		await onSubmit();
		modalService.closeModal();
	}, [modalService, onSubmit, submitting]);

	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			if (event.key !== 'Enter' && event.code !== 'NumpadEnter') {
				return;
			}

			event.preventDefault();
			void handleConfirm();
		};

		window.addEventListener('keydown', handleKeyDown);

		return () => {
			window.removeEventListener('keydown', handleKeyDown);
		};
	}, [handleConfirm]);

	return (
		<StyledDeleteModal>
			<div className="title">{title ?? 'Delete'}</div>
			<div className="description">{text ?? 'Are you sure you want to delete this?'}</div>
			<div className="buttons">
				<Button
					secondary
					disabled={submitting}
					title={t('standard.standardList.buttons.deleteDraftCancel')}
					onClick={() => modalService.closeModal()}
				/>
				<Button
					disabled={submitting}
					title={t('standard.standardList.buttons.deleteDraftConfirm')}
					onClick={handleConfirm}
				/>
			</div>
		</StyledDeleteModal>
	);
}
